"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var luxon_1 = require("luxon");
var react_i18next_1 = require("react-i18next");
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var interpolation = {
    escapeValue: false,
    formatSeparator: ",",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    format: function (value, format, lng) {
        var castedFormat = format;
        if (value instanceof Date && typeof lng !== "undefined" && typeof format !== "undefined") {
            if (format === "yearMonthDayDateTime") {
                var dateTime = luxon_1.DateTime.fromJSDate(value).setLocale(lng);
                var day = dateTime.get("day");
                var month = dateTime.get("month");
                var year = dateTime.get("year");
                var time = dateTime.toLocaleString(luxon_1.DateTime["TIME_24_WITH_SECONDS"]);
                var dateTimeValue = "".concat(year, "/").concat(month, "/").concat(day, " ").concat(time);
                return dateTimeValue;
            }
            else if (format === "DATE_DAY_MONTH_YEAR") { // format like 16/03/2023 
                var dateTime = luxon_1.DateTime.fromJSDate(value).setLocale(lng);
                var day = dateTime.get("day");
                var month = dateTime.get("month");
                var year = dateTime.get("year");
                return "".concat(day, "/").concat(month, "/").concat(year);
            }
            else {
                return luxon_1.DateTime.fromJSDate(value).setLocale(lng).toLocaleString(luxon_1.DateTime[castedFormat]);
            }
        }
        if (typeof value === "number") {
            // The formatted number needs to be reformatted back to javascript number format before saving in the backend.
            var numberFormatter = new Intl.NumberFormat(lng);
            return numberFormatter.format(value);
        }
        return value;
    },
};
i18next_1.default.use(i18next_http_backend_1.default).use(i18next_browser_languagedetector_1.default).use(react_i18next_1.initReactI18next).init({
    fallbackLng: "en",
    debug: false,
    interpolation: interpolation,
    keySeparator: "."
});
if (process.env.CYPRESS_TESTING && process.env.CYPRESS_TESTING == "true")
    i18next_1.default.changeLanguage("en"); // Cypress testing
exports.default = i18next_1.default;
